import qs from "qs";

import PolygonApi from "../../services/api/Polygon";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath, unFlattenObj } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in polygon actions:", err);
}

export const setPolygonTypes = (payload) => {
  return {
    type: ActionTypes.SET_POLYGON_TYPES,
    payload,
  };
};

export const setPolygonList = (payload) => {
  return {
    type: ActionTypes.SET_POLYGON_LIST,
    payload,
  };
};

export const setCurrentPagePolygon = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_POLYGON,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_POLYGON_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_POLYGON,
    payload,
  };
};

export const getPolygonList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };

      // remove the "polygon." prefix from filters.
      if (Object.keys(filters).length > 0) {
        Object.keys(filters).forEach((key) => {
          const filterKey = key.replace("polygon.", "");
          finalPayload[filterKey] = filters[key];
        });
      }

      // channge ref_id to startswith
      if (getPath(finalPayload, "ref_id", undefined)) {
        finalPayload["startswith"] = finalPayload["ref_id"];
        delete finalPayload["ref_id"];
      }

      // change city_id to array
      if (
        getPath(finalPayload, "city_id", undefined) &&
        !Array.isArray(finalPayload["city_id"])
      ) {
        finalPayload["city_id"] = [finalPayload["city_id"]];
      }

      const queryParams = qs.stringify(finalPayload, { 
        addQueryPrefix: true,
        arrayFormat: "brackets",
      });
      dispatch(setLoader(true));
      let response = await PolygonApi.getPolygonList(queryParams);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setPolygonList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPagePolygon(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getBulkPolygons = (polygonIds) => async (dispatch) => {
  try {
    var polygons = [];
    dispatch(setLoader(true));
    for (const id of polygonIds) {
      let finalPayload = {
        id: id,
      };
      let response = await PolygonApi.getPolygon(finalPayload);
      if (response) {
        polygons = [...polygons, getPath(response, "polygon", {})];
      }
    }
    dispatch(setLoader(false));
    return polygons;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createPolygon = (data) => async (dispatch) => {
  try {
    let finalPayload = unFlattenObj(data);
    dispatch(setLoader(true));
    let response = await PolygonApi.createPolygon(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      if (response.status.code === 570 || response.status.code === 571 || response.status.code === 572) {
        dispatch(
          setStatus({
            type: "error",
            message: response.status.message,
          })
        );
      }
      else {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.CREATION_SUCCESS,
          })
        );
        dispatch(resetState({ state: "activePolygon" }));
      }
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updatePolygon = (id, data) => async (dispatch) => {
  try {
    const finalPayload = unFlattenObj(data);
    dispatch(setLoader(true));
    const response = await PolygonApi.updatePolygon(id, finalPayload);
    dispatch(setLoader(false));
    if (response) {
      if (response.status.code === 573 || response.status.code === 572) {
        dispatch(
          setStatus({
            type: "error",
            message: response.status.message,
          })
        );
      }
      else {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
        dispatch(resetState({ state: "activePolygon" }));
      }
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const setActivePolygon = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_POLYGON,
    payload,
  };
};

export const getPolygon = (id) => async (dispatch) => {
  try {
    let finalPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    let response = await PolygonApi.getPolygon(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActivePolygon(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(setStatus({ type: "error", message: ErrorMsgs.GENERAL_ERROR_1 }));
    handleError(err);
  }
};

export const getPolygonTypes = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await PolygonApi.getPolygonTypes();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setPolygonTypes(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(setStatus({ type: "error", message: ErrorMsgs.GENERAL_ERROR_1 }));
    handleError(err);
  }
};
